export default __webpack_public_path__ + "static/media/a017-4.023e0bf6.svg";